import { CustomQueryOptions } from '@/common/types_and_interfaces'
import { queryOptions } from '@tanstack/react-query'
import {
  GETMarketplaceAffiliations,
  GETMarketplaceItemsByProvider,
  GETMarketplaceStores,
} from './requests.ts'

export const MarketplaceQueryKeys = {
  stores: (
    programId: number,
    business_type?: string,
    search?: string,
    acceptingNewClients?: number,
    perPage?: number,
    page?: number,
    mySchools?: boolean
  ) => [
    'marketplace_stores',
    programId,
    business_type,
    search,
    acceptingNewClients,
    perPage,
    page,
    mySchools,
  ],
  itemsByProvider: (
    programId: number,
    providerId: number,
    business_type?: string,
    search?: string,
    perPage?: number,
    page?: number
  ) => [
    'marketplace_items_by_provider',
    programId,
    providerId,
    business_type,
    search,
    perPage,
    page,
  ],
  affiliations: (
    programId: number,
    search?: string,
    acceptingNewClients?: number,
    perPage?: number,
    page?: number
  ) => [
    'marketplace_affiliations',
    programId,
    search,
    acceptingNewClients,
    perPage,
    page,
  ],
} as const

export class MarketplaceQueries {
  public static getMarketplaceStores(
    programId: number,
    business_type?: string,
    search?: string,
    acceptingNewClients?: number,
    perPage: number = 10,
    page: number = 1,
    mySchools: boolean = false,
    options: CustomQueryOptions<any> = {}
  ) {
    return queryOptions({
      queryKey: MarketplaceQueryKeys.stores(
        programId,
        business_type,
        search,
        acceptingNewClients,
        perPage,
        page,
        mySchools
      ),
      queryFn: () =>
        GETMarketplaceStores(
          programId,
          business_type,
          search,
          acceptingNewClients,
          perPage,
          page,
          mySchools
        ),
      ...options,
    })
  }

  public static getItemsByProvider(
    programId: number,
    providerId: number,
    business_type?: string,
    search?: string,
    perPage?: number,
    page?: number,
    options: CustomQueryOptions<any> = {}
  ) {
    return queryOptions({
      queryKey: MarketplaceQueryKeys.itemsByProvider(
        programId,
        providerId,
        business_type,
        search,
        perPage,
        page
      ),
      queryFn: () =>
        GETMarketplaceItemsByProvider(
          programId,
          providerId,
          business_type,
          search,
          perPage,
          page
        ),
      ...options,
    })
  }

  public static getMarketplaceAffiliations(
    programId: number,
    search?: string,
    acceptingNewClients?: number,
    perPage: number = 10,
    page: number = 1,
    options: CustomQueryOptions<any> = {}
  ) {
    return queryOptions({
      queryKey: MarketplaceQueryKeys.affiliations(
        programId,
        search,
        acceptingNewClients,
        perPage,
        page
      ),
      queryFn: () =>
        GETMarketplaceAffiliations(
          programId,
          search,
          acceptingNewClients,
          perPage,
          page
        ),
      ...options,
    })
  }
}
